<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        waringTypeOptions: [],
        orgIdOptions: [],
        form: [
          { // 角色名称
            label: '角色名称',
            value: 'roleName',
            type: 'input',
            placeholder: '请输入角色名称',
          },
          { // 创建人
            label: '创建人',
            value: 'opName',
            type: 'input',
            placeholder: '请输入创建人',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
